import { BaseEntity } from '../../../../models';
import { Usuario } from '../../../usuario/usuario';

export class RepresentanteGerente implements BaseEntity {
    readonly id: number;
    idRepresentante: number;
    idUsuarioGerente: number;
    usuarioGerente: Usuario;
}
